import { IMyDate, IMyOptions, UtilService as NgxMyUtilService } from '@nodro7/angular-mydatepicker';

export class DatePickerUtil {
    static parseDate(value: Date | string | number, config: IMyOptions): Date {
        if (!value) {
            return undefined;
        }
        if (typeof value === 'string') {
            const ngxMyDate: IMyDate = DatePickerUtil.getNgxMyDate(value, config);
            if (DatePickerUtil.isMyDateEmpty(ngxMyDate)) {
                return undefined;
            }
            return NgxMyUtilService.prototype.myDateToJsDate(ngxMyDate);
        } else if (typeof value === 'number') {
            return new Date(value);
        } else if (value instanceof Date) {
            return value;
        }
        return undefined;
    }

    static isDateValid(value: Date | string | number, config: IMyOptions): boolean {
        if (!value) {
            return false;
        }
        if (typeof value === 'string') {
            const ngxMyDate: IMyDate = DatePickerUtil.getNgxMyDate(value, config);
            return !DatePickerUtil.isMyDateEmpty(ngxMyDate);
        } else if (typeof value === 'number') {
            return !isNaN(new Date(value).getTime());
        }
        return value instanceof Date;
    }

    // Seltsamerweise liefert isDateValid entweder Date oder, wenn nicht valid {day: 0, month: 0, year: 0}
    private static getNgxMyDate(date: string, config: IMyOptions) {
        return NgxMyUtilService.prototype.isDateValid(
            date,
            config,
            {}
        );
    }

    private static isMyDateEmpty(ngxMyDate: IMyDate): boolean {
        return ngxMyDate.day === 0 && ngxMyDate.month === 0 && ngxMyDate.year === 0;
    }
}
